import type { SupportingMethod } from '../types.js';

export const supertrend: SupportingMethod = ({ candles, direction }) => {
  const period = 10;
  const multiplier = 3;
  if (candles.length < period + 10 || direction === 'neutral') {
    return { id: 'MO-025', name: 'Supertrend', status: 'experimental', authority: 1, rawSignal: 0, contribution: 0, direction, finding: 'Insufficient candle history or no Core direction.', dataSufficient: false, sampleSize: candles.length };
  }
  const tr: number[] = [];
  for (let i = 0; i < candles.length; i += 1) {
    const c = candles[i]!; const p = candles[i - 1];
    tr.push(i === 0 ? c.high - c.low : Math.max(c.high - c.low, Math.abs(c.high - p!.close), Math.abs(c.low - p!.close)));
  }
  let atr = tr.slice(0, period).reduce((sum, value) => sum + value, 0) / period;
  let finalUpper = Number.POSITIVE_INFINITY;
  let finalLower = Number.NEGATIVE_INFINITY;
  let trend: 'up' | 'down' = 'up';
  for (let i = period; i < candles.length; i += 1) {
    atr = (atr * (period - 1) + tr[i]!) / period;
    const c = candles[i]!;
    const hl2 = (c.high + c.low) / 2;
    const basicUpper = hl2 + multiplier * atr;
    const basicLower = hl2 - multiplier * atr;
    const previous = candles[i - 1]!;
    finalUpper = basicUpper < finalUpper || previous.close > finalUpper ? basicUpper : finalUpper;
    finalLower = basicLower > finalLower || previous.close < finalLower ? basicLower : finalLower;
    if (trend === 'down' && c.close > finalUpper) trend = 'up';
    else if (trend === 'up' && c.close < finalLower) trend = 'down';
  }
  const aligned = (direction === 'long' && trend === 'up') || (direction === 'short' && trend === 'down');
  return {
    id: 'MO-025', name: 'Supertrend', status: 'experimental', authority: 1, rawSignal: aligned ? 1 : 0, contribution: aligned ? 1 : 0, direction,
    finding: aligned ? `Supertrend state is ${trend}, aligned with the Core ${direction} direction.` : `Supertrend state is ${trend}, not aligned with the Core ${direction} direction.`,
    dataSufficient: true, sampleSize: candles.length,
  };
};
